export const createAdapter = type => ({
  isValid: ({ option: { type: optionType } }) => optionType === type,
  transform: ({ option: { key, id }, parents }) => ({
    type,
    name: key,
    values: [id],
    parents,
  }),
});
